import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import Setup from "./toStripe";
import Funding from "./Funding";
import { AuthProvider } from "./Auth";
import PrivateRoute from "./PrivateRoute";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { auth } from "./base";
import Finish from "./Finish";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    height: '60px'
  },
  title: {
    flexGrow: 1,
  },
  devColor: {
    backgroundColor: '#0e2a51'
  }
}));
const App = () => {
  const classes = useStyles();
  return (
    <AuthProvider>
      <Router>
        <Route exact path="/login" component={Login} />
        <div>
        <AppBar position="static" className={classes.devColor}>
  <Toolbar>
    <img className={classes.menuButton} src="AurafareLogo.png"/>
    <Typography variant="h6" className={classes.title}>
      Aurafare Developement Mode
    </Typography>
    <Button color="inherit" onClick={() => auth.signOut()}>Sign Out</Button>
  </Toolbar>
</AppBar>
          <PrivateRoute exact path="/" component={Home} />
          <PrivateRoute exact path="/setup" component={Setup} />
          <PrivateRoute exact path="/funding" component={Funding} />
          <PrivateRoute exact path="/finish" component={Finish} />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
